"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSurveyId = exports.getSourceType = void 0;
var lodash_1 = __importDefault(require("lodash"));
function getSourceType(sourceId) {
    return lodash_1.default.startsWith(sourceId, 'SV_') ? "survey" /* SURVEY */ : "fieldset" /* FIELDSET */;
}
exports.getSourceType = getSourceType;
function isSurveyId(sourceId) {
    return !!sourceId && (getSourceType(sourceId) === "survey" /* SURVEY */);
}
exports.isSurveyId = isSurveyId;
